import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../analytics'

/**
 * Fires the legacy `screens_pageview` GTM event on every route change.
 * Mounted once inside the Router; the legacy app fired the equivalent per
 * page on mount, so a single location-watcher reproduces it for all routes.
 */
export function RouteAnalytics() {
  const { pathname } = useLocation()
  useEffect(() => {
    trackPageView(pathname)
  }, [pathname])
  return null
}
